import React from 'react';
import '../App.css';

const About=()=>{
  return(
    <div className="About">
      <h1>About</h1>
      <h2>
        Say anything. <br/>
        Upvote or downvote what others say.<br/>
        What you say will be permanently etched here.
      </h2>
      *Updated to reject empty posts, thank you whoever tested that!*
    </div>
  );
}
export default About;



// WEBPACK FOOTER //
// ./src/Components/About.js